// @tenorlab/nuxt-dashboard-pro
// file: src/async-widgets/widget-commodity-prices/meta.ts
import type { TWidgetMetaInfo } from '@tenorlab/vue-dashboard'
import { markRaw } from 'vue'
import { MonitorIcon as ComponentIcon } from '@tenorlab/vue-dashboard'

// Define the metadata object for the plugin
export const WidgetCommodityPricesMeta: TWidgetMetaInfo = {
  name: 'Commodity Prices',
  categories: ['Widget', 'Chart'],
  icon: markRaw(ComponentIcon),
  noDuplicatedWidgets: true,
  description: 'Displays real-time commodity prices (Gold/Silver).',
  externalDependencies: [],
}
